import { Grid, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from '../../contexts/translation';
import { LocalUserInputs } from '../../types/app/localUser.types';
interface Props {
  onSubmit: SubmitHandler<LocalUserInputs>;
  defaultValues?: LocalUserInputs;
  onBack: any;
  isReadOnly?: boolean;
  isDetail?: boolean;
}

export function LocalUserForm({ onSubmit, defaultValues, onBack, isReadOnly, isDetail }: Props) {
  const { t } = useTranslation();
  const [tmpPassword1, setTmpPassword1] = useState<string>();
  const [tmpPassword2, setTmpPassword2] = useState<string>();
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm<LocalUserInputs>();

  useEffect(() => {
    if (!tmpPassword1 && !tmpPassword2) return;
    if (tmpPassword1 !== tmpPassword2) {
      setError('password', {
        type: 'custom',
        message: t('page.local-user.passwords-do-not-match'),
      });
    } else {
      clearErrors();
    }
  }, [tmpPassword1, tmpPassword2]);

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              value={defaultValues && defaultValues.id ? defaultValues.id : undefined}
              label={t('page.local-user.edit-input-label-1')}
              {...register('id', { required: t('page.local-user.validation-required-id') })}
              error={Boolean(errors.id)}
              helperText={errors.id?.message}
              disabled={isReadOnly || isDetail}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              required
              value={defaultValues && defaultValues.name ? defaultValues.name : undefined}
              label={t('page.local-user.edit-input-label-2')}
              {...register('name', { required: t('page.local-user.validation-required-name') })}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              disabled={isReadOnly}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              value={defaultValues && defaultValues.email ? defaultValues.email : undefined}
              label={t('page.local-user.edit-input-label-3')}
              {...register('email')}
              error={Boolean(errors.email)}
              helperText={errors.email?.message}
              disabled={isReadOnly}
            />
          </Grid>
          {!isDetail && (
            <>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label={t('page.local-user.edit-input-label-4')}
                  onChange={(e: any) => {
                    if (e.target.value) setTmpPassword1(e.target.value);
                  }}
                  type={'password'}
                  error={Boolean(errors.password)}
                  helperText={errors.password?.message}
                  disabled={isReadOnly}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label={t('page.local-user.edit-input-label-5')}
                  {...register('password', {
                    onChange: (e: any) => {
                      if (e.target.value) setTmpPassword2(e.target.value);
                    },
                  })}
                  type={'password'}
                  error={Boolean(errors.password)}
                  helperText={errors.password?.message}
                  disabled={isReadOnly}
                />
              </Grid>
            </>
          )}
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={!isDetail && (!tmpPassword1 || !tmpPassword2)}
              >
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
